<template>
  <div class="app-navbar-actions">
    <!-- 20240930 comment - Hide settings, notifications and profile in lean version.
    <SettingsDropdown class="app-navbar-actions__item"  />
    <NotificationDropdown class="app-navbar-actions__item" />
    -->
    <!-- Language switcher: English / Czech -->
    <div class="language-switcher" aria-label="Language switcher">
      <button class="lang-btn" :class="{ active: locale === 'gb' }" type="button" @click="setLocale('gb')">
        <img class="flag" src="/flags/gb.svg" alt="English" />
        <span class="code">EN</span>
      </button>
      <button class="lang-btn" :class="{ active: locale === 'cz' }" type="button" @click="setLocale('cz')">
        <img class="flag" src="/flags/cz.svg" alt="Čeština" />
        <span class="code">CS</span>
      </button>
    </div>

    <!-- 20240930 comment - Show theme switcher in lean version. -->
    <div class="theme-container">
      <div class="theme-icon-wrapper">
        <ThemeSwitcher />
      </div>
      <span class="theme-text">{{ $t('common.theme') }}</span>
    </div>

    <ProfileDropdown class="app-navbar-actions__item app-navbar-actions__item--profile mr-1" />
    <!-- 20240930 comment - Just keep the logout button in lean version. -->
  </div>
</template>

<script lang="ts" setup>
import ThemeSwitcher from '../../../pages/settings/theme-switcher/ThemeSwitcher.vue'
import ProfileDropdown from './dropdowns/ProfileDropdown.vue'

defineProps({
  isMobile: { type: Boolean, default: false },
})

import { useI18n } from 'vue-i18n'
const { locale } = useI18n()

const setLocale = (code: 'gb' | 'cz') => {
  locale.value = code
}
</script>

<style lang="scss">
.app-navbar-actions {
  display: flex;
  align-items: center;

  .va-dropdown__anchor {
    color: var(--va-primary);
    fill: var(--va-primary);
  }

  &__item {
    padding: 0;
    margin-left: 0.25rem;
    margin-right: 0.25rem;

    svg {
      height: 20px;
    }

    &--profile {
      display: flex;
      justify-content: center;
    }

    .va-dropdown-content {
      background-color: var(--va-white);
    }

    @media screen and (max-width: 640px) {
      margin-left: 0;
      margin-right: 0;

      &:first-of-type {
        margin-left: 0;
      }
    }
  }

  .fa-github {
    color: var(--va-on-background-primary);
  }
}

.language-switcher {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-right: 1rem;
  padding: 2px;
  border-radius: 16px;
  background: rgba(0, 0, 0, 0.04);
  border: 1px solid rgba(0, 0, 0, 0.08);
}

.lang-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 2px 6px;
  border-radius: 14px;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 11px;
  font-weight: 500;
  color: var(--va-navbar-text-color, #000000);
  transition:
    background 0.15s ease,
    box-shadow 0.15s ease,
    transform 0.1s ease;
}

.lang-btn .flag {
  width: 18px;
  height: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 2px;
  overflow: hidden;
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.08);
}

.lang-btn .code {
  text-transform: uppercase;
}

.lang-btn.active {
  background: rgba(0, 0, 0, 0.06);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);
}

.lang-btn:hover {
  background: rgba(0, 0, 0, 0.08);
  transform: translateY(-1px);
}

.theme-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  margin-right: 1rem;
  position: relative;
}

.theme-text {
  color: var(--va-navbar-text-color, #000000);
  font-size: 12px;
  font-weight: 500;
  opacity: 1 !important;
  visibility: visible !important;
}

.theme-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
}

.theme-container :deep(.theme-dropdown) {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 4px;
  z-index: 1000;
}

.theme-container :deep(.theme-dropdown-button) {
  background: transparent;
  border: none;
  padding: 0;
  min-width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: rgba(0, 0, 0, 0.08);
    border-radius: 4px;
  }
}

.theme-container :deep(.va-icon) {
  color: var(--va-navbar-text-color, #000000) !important;
  font-size: 24px;
  opacity: 1 !important;
  visibility: visible !important;
}

.theme-container :deep(.theme-toggle-button) {
  color: var(--va-navbar-text-color, #000000) !important;
  opacity: 1 !important;
  visibility: visible !important;
  background: transparent !important;

  .va-icon {
    color: var(--va-navbar-text-color, #000000) !important;
    opacity: 1 !important;
    visibility: visible !important;
  }

  .va-button__content {
    color: var(--va-navbar-text-color, #000000) !important;
    opacity: 1 !important;
  }
}
</style>
